import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../components/common/Navbar';
import Sidebar from '../components/common/Sidebar';
import PatientList from '../components/patients/PatientList';
import PatientForm from '../components/patients/PatientForm';
import PatientDetail from '../components/patients/PatientDetail';
import TreatmentForm from '../components/treatments/TreatmentForm';
import patientService from '../services/patientService';

const Patients = () => {
  const location = useLocation();
  const [showForm, setShowForm] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [showDetail, setShowDetail] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [showTreatmentForm, setShowTreatmentForm] = useState(false);

  // Handle navigation from Documents page
  useEffect(() => {
    if (location.state?.openPatient) {
      const patientId = location.state.openPatient;
      fetchAndOpenPatient(patientId);
    }
  }, [location.state]);

  const fetchAndOpenPatient = async (patientId) => {
    try {
      const response = await patientService.getPatientById(patientId);
      setSelectedPatient(response.data);
      setShowDetail(true);
    } catch (error) {
      console.error('Error fetching patient:', error);
    }
  };

  const handleAddPatient = () => {
    setSelectedPatient(null);
    setShowForm(true);
  };

  const handleSelectPatient = (patient) => {
    setSelectedPatient(patient);
    setShowDetail(true);
  };

  const handleEditPatient = (patient) => {
    setSelectedPatient(patient);
    setShowDetail(false);
    setShowForm(true);
  };

  const handleAddTreatment = (patient) => {
    setSelectedPatient(patient);
    setShowTreatmentForm(true);
  };

  const handleCloseTreatmentForm = () => {
    setShowTreatmentForm(false);
  };

  const handleCloseForm = () => {
    setShowForm(false);
    setSelectedPatient(null);
  };

  const handleCloseDetail = () => {
    setShowDetail(false);
    setSelectedPatient(null);
  };

  const handleSuccess = () => {
    setRefreshKey((prev) => prev + 1);
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <Navbar />
      
      <div className="flex">
        <Sidebar />
        
        <div className="flex-1 p-8">
          <div className="mb-6">
            <h1 className="text-3xl font-bold text-gray-900">Patients</h1>
            <p className="text-gray-600 mt-1">
              Manage your patient records and information
            </p>
          </div>

          <PatientList
            refreshKey={refreshKey}
            onSelectPatient={handleSelectPatient}
            onAddPatient={handleAddPatient}
            onEditPatient={handleEditPatient}
          />
        </div>
      </div>

      {/* Patient Form Modal */}
      {showForm && (
        <PatientForm
          patient={selectedPatient}
          onClose={handleCloseForm}
          onSuccess={handleSuccess}
        />
      )}

      {/* Patient Detail Modal */}
      {showDetail && (
        <PatientDetail
          patient={selectedPatient}
          onClose={handleCloseDetail}
          onEdit={handleEditPatient}
          onSuccess={handleSuccess}
          onAddTreatment={handleAddTreatment}
        />
      )}

      {/* Treatment Form Modal */}
      {showTreatmentForm && (
        <TreatmentForm
          preSelectedPatient={selectedPatient}
          onClose={handleCloseTreatmentForm}
          onSuccess={handleSuccess}
        />
      )}
    </div>
  );
};

export default Patients;